import React from "react";
import Select from "react-select";

const AppSelect = ({ styles, ...props }) => (
    <Select
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        {...props}
        styles={{
            ...styles,
            menuPortal: (base) => ({
                ...(styles?.menuPortal ? styles.menuPortal(base) : base),
                zIndex: 9999,
            }),
        }}
    />
);

export default AppSelect;
